export default __webpack_public_path__ + "static/media/sw7.265e6187.jpg";